import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/hooks';
import styles from './Design.module.css';
import { selectSession } from 'src/store/session/sessionSelects';
import { Webview } from 'src/components/webview/Webview';
import { RequestStatus } from '../../enums/request-status';
import { Status } from 'src/components/status/Status';
import { getDesignAsync } from 'src/store/design/actionDesign';
import { shallowEqual } from 'react-redux';
import { selectDesignRequestStatus } from 'src/store/design/designSelects';
import biLoggingService, {StageReportData} from 'src/services/bi-logging/bi-logging.service';

export function Design() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(
            getDesignAsync({
                orderId: session.orderId,
                messageId: session.csmMessageId,
                bizContext: session.bizContextBase64
            })
        );

        const stageReportData: StageReportData = {
            object: 'design',
            stage: 'opening start'
        };
        biLoggingService.sendStageReport(stageReportData);
    }, []);
    const session = useAppSelector(selectSession, shallowEqual);
    const designRequestStatus = useAppSelector(selectDesignRequestStatus, shallowEqual);

    const webWView = () => {
        switch (designRequestStatus) {
            case RequestStatus.Completed:
                return (
                    <div className={styles.container}>
                        <Webview />
                        <Status />
                    </div>
                );
            default:
                return null;
        }
    };
    return <div className={styles.container}>{webWView()}</div>;
}
